export default "__VITE_ASSET__B86X0n3U__"